import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from 'react-icons/fa';
import { getAgentLeads, getLeadConfig, lead_insert, updateUserDetails } from "../../../api/lead";
import { Toast } from "bootstrap";
import LeadTable from "../leads/leadTable";

const UserEdit = () => {
  const location = useLocation();
  const { user_data } = location.state || {};
  const toastRef = useRef(null);
  const navigate = useNavigate();
  const [updateMessage, setUpdateMessage] = useState('');

  const [loadingData, setLoadingData] = useState(false);
  const [configuration, setConfiguration] = useState(null);
  const [leads, setLeads] = useState([]);

  const safeConfig = configuration || {};
  const safeLeadStatuses = Array.isArray(safeConfig.lead_status) ? safeConfig.lead_status : [];
  const [formData, setFormData] = useState({
    name: user_data?.name || '',
    email: user_data?.email || '',
    mobile: user_data?.mobile || '',
    user_type: user_data?.user_type || '',
    bucket: user_data?.buckets?.[0]?.id || '',
    is_active: user_data?.is_active || false,
    is_blocked: user_data?.is_blocked || false
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        const types = "lead_types,lead_sources,buckets,country,lead_status,priority,followup_type";
        const [leadsData, configData] = await Promise.all([
          getAgentLeads(user_data.id),
          getLeadConfig(types)
        ]);

        if (leadsData.status && configData.status) {
          setLeads(leadsData.data);
          setConfiguration(configData.data);
          setLoadingData(false);
        }
      } catch (error) {
        console.log("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  // leads.forEach(lead => {
  //   if (count.hasOwnProperty(lead.status_id)) {
  //     count[lead.status_id]++;
  //   }
  // });

  const statusIds = safeLeadStatuses.map((status) => status.id);
  const count = statusIds.reduce((acc, id) => {
    acc[id] = 0;
    return acc;
  }, {});

  leads.forEach((lead) => {
    if (count.hasOwnProperty(lead.status_id)) {
      count[parseInt(lead.status_id)]++;
    }
  });

  const handleBookDemo = async (e) => {
    e.preventDefault();
    let update_data = {
      "type": "admin",
      "user_id": user_data.id,
        ...formData
    }
    const response = await updateUserDetails(update_data)
    setUpdateMessage('Settings updated successfully!');
    setTimeout(() => setUpdateMessage(''), 3000); 
    // Uncomment when ready to submit:
    // const response = await lead_insert(formData);
    // if (response.status === true && toastRef.current) {
    //   const toast = new Toast(toastRef.current);
    //   toast.show();
    // }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleBackClick = () => {
    navigate("/home/users");
  };

  return (
    <>
      <div className="mt-4 mb-4">
        <div className="row">
          <div className="col">
            <button className="btn btn-secondary" onClick={handleBackClick}>
              ← Back
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        {/* Left Side: Form */}
        {updateMessage && (
                <div className="alert alert-success d-flex align-items-center rounded-3 mb-4" role="alert">
                  <FaCheckCircle className="flex-shrink-0 me-2" size={20} />
                  <div>{updateMessage}</div>
                </div>
              )}
        <div className="col-7">
          <form>
            <div className="mb-3">
              <label className="form-label fw-semibold">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">E-mail</label>
              <input
                type="email"
                className="form-control"
                placeholder="E-mail ID"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Phone No.</label>
              <input
                type="tel"
                className="form-control"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Role</label>
                <select
                  className="form-select"
                  name="user_type"
                  value={formData.user_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Agent">Agent</option>
                  <option value="Manager">Manager</option>
                  <option value="Admin">Admin</option>
                </select>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Bucket</label>
                <select
                  className="form-select"
                  name="bucket"
                  value={formData.bucket}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  {configuration?.buckets?.map((bucket) => (
                    <option key={bucket.id} value={bucket.id}>
                      {bucket.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            
            {/* {
              formData.user_type.toLowerCase() == 'student' ? <></>
              :<div className="home-list-table mt-4">
              <label className="form-label fw-semibold">Leads</label>
              <LeadTable leads={leads} users={[user_data.id]} configuration={configuration}/>
            </div>
            } */}
            
          </form>
        </div>

        {/* Right Side: Stats & Controls */}
        <div className="col-5">
          <div className="p-2 bg-light rounded">
            <div className="container-fluid mt-4">
              <h2 className="mb-2">User Stats</h2>
              <div className="row g-3">
                <div className="col-lg-4 col-md-6">
                  <div className="card text-center p-2" style={{ backgroundColor: "#e9f5ff", border: "1px solid #d4eeff" }}>
                    <div className="card-body d-flex flex-column justify-content-center align-items-center">
                      <h1 className="display-5 fw-bold">{user_data?.lead_count}</h1>
                      <p className="lead text-primary">Total Leads</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-8 col-md-6">
                  <div className="row g-3">
                    {
                      safeLeadStatuses?.map((status) => (
                        // console.log(status.id)
                        // console.log('status: '+status.id +' count: ' + count[status.id])
                        count[status.id] !== 0 ? (
                        <div className="col-sm-6">
                          <div className="card p-3">
                            <h6 className="mb-0">{status?.name}</h6>
                            <p className="mb-0 fs-5 fw-bold">{count[status?.id]}</p>
                          </div>
                        </div>
                        ) : null 
                      ))
                    }
                    {/* <div className="col-sm-6">
                      <div className="card p-3">
                        <h6 className="mb-0">Assigned</h6>
                        <p className="mb-0 fs-5 fw-bold">{count[200]}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card p-3">
                        <h6 className="mb-0">In Progress</h6>
                        <p className="mb-0 fs-5 fw-bold">{count[300]}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card p-3">
                        <h6 className="mb-0">Dead</h6>
                        <p className="mb-0 fs-5 fw-bold">{count[500]}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card p-3">
                        <h6 className="mb-0">Converted</h6>
                        <p className="mb-0 fs-5 fw-bold">{count[400]}</p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="mb-3 mt-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="is_blocked"
                  checked={formData.is_blocked}
                  onChange={handleChange}
                />
                <label className="form-check-label fw-semibold">Block User</label>
              </div>

              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                />
                <label className="form-check-label fw-semibold">Set Active</label>
              </div>

              <div>
                <button
                  type="button"
                  className="primary-button btn-lg btn btn-primary w-100 rounded-pill mt-2"
                  onClick={handleBookDemo}
                >
                  Update
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserEdit;
